import { motion } from "framer-motion";

export function Spinner() {
  return (
    <motion.div
      className="inline-block h-4 w-4 rounded-full border-2 border-current border-t-transparent"
      animate={{ rotate: 360 }}
      transition={{
        duration: 0.8,
        repeat: Infinity,
        ease: "linear",
      }}
    />
  );
}
